const LONG_RECALC_MS = 60 * 60 * 1000;

const isStale = (account) => account.stale === true || account.participation === 'NO_CURRENT_YEAR_CALCULATION';

const errorVariant = (error) => {
  const code = error.data?.code;
  if (error.status === 429 && code === 'tax_planner.snapshot_rate_exceeded') return 'rate-limited';
  if (error.status === 403 && code === 'tax_planner.not_available_for_country') return 'unavailable';
  return 'error';
};

const recalculatingVariant = (accounts, nowMs) => {
  const latest = Math.max(...(accounts || []).map((a) => new Date(a.confirmDateTime).getTime()));
  return nowMs - latest > LONG_RECALC_MS ? 'recalculating-long' : 'recalculating';
};

export const chooseEntryWindow = ({ response, error, pick, staleAcknowledged, now }) => {
  if (error) return { variant: errorVariant(error), staleAccounts: [] };
  if (!response) return { variant: 'loading', staleAccounts: [] };

  switch (response.state) {
    case 'NO_REPORTS':
      return { variant: 'empty', staleAccounts: [] };
    case 'PHANTOM_YEAR':
      return { variant: 'phantom-year', staleAccounts: [] };
    case 'RECALCULATING':
      return { variant: recalculatingVariant(response.accounts, new Date(now).getTime()), staleAccounts: [] };
    case 'READY': {
      const staleAccounts = (response.accounts || []).filter(isStale);
      if (staleAccounts.length && !staleAcknowledged) return { variant: 'stale', staleAccounts };
      return { variant: pick?.reason ? 'cannot-reduce' : 'default', staleAccounts };
    }
    default:
      return { variant: 'error', staleAccounts: [] };
  }
};
